// The X-Acting-As header: an admin managing a creator's account acts as that
// creator (common/get_user.py get_current_user swaps the user). It is kept in
// localStorage, so it used to go on EVERY request, including the admin's
// visits to OTHER creators' Hubs, where they were treated as the creator they
// manage: that creator's products and Hub order drawn on someone else's page,
// and that creator's access, purchases and comments used there.
//
// So it is decided by the page: on a creator's page (the /:influencer_name
// route, or a custom domain) that isn't the managed creator's, nothing acts as
// her - storefront, checkout, comments, joining all go as the admin's own
// account. Everywhere else - her own pages (her settings and "My
// subscriptions" are under /<her username>) and app pages such as /settings -
// still acts as her. Influencer.js says which creator's page is open
// (setPageCreator).

let pageCreator = '';

/** The creator whose page is open ('' when it isn't a creator's page). */
export function setPageCreator(username) {
  pageCreator = String(username || '').trim();
}

function currentPageCreator() {
  if (pageCreator) return pageCreator;
  try {
    // A custom domain's renderer names the creator it serves.
    return (typeof window !== 'undefined' && window.__CUSTOM_DOMAIN_CREATOR__) || '';
  } catch (e) {
    return '';
  }
}

function storedActingAs() {
  try {
    return localStorage.getItem('acting_as_creator') || '';
  } catch (e) {
    return '';
  }
}

/** The X-Acting-As value to send, or '' to send none. */
export function actingAsFor(actingAs = storedActingAs(), page = currentPageCreator()) {
  if (!actingAs) return '';
  const open = String(page || '').trim().toLowerCase();
  if (open && !['undefined', 'null'].includes(open) && open !== actingAs.toLowerCase()) {
    return '';
  }
  return actingAs;
}
